import {
  PublicClientApplication,
  InteractionRequiredAuthError,
  BrowserAuthError,
  CacheLookupPolicy,
} from '@azure/msal-browser';
import onlineService from './onlineService';

const scopes = [`${process.env.VUE_APP_AZUREAD_CLIENT_ID}/.default`];

const msal = new PublicClientApplication({
  auth: {
    clientId: process.env.VUE_APP_AZUREAD_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.VUE_APP_AZUREAD_TENANT_ID}`,
    redirectUri: process.env.VUE_APP_AZUREAD_REDIRECT_URI,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
});

const initializePromise = msal.initialize();

function getAccount() {
  const activeAccount = msal.getActiveAccount();
  if (activeAccount) {
    return activeAccount;
  }

  const accounts = msal.getAllAccounts();
  if (accounts.length > 0) {
    msal.setActiveAccount(accounts[0]);
    return accounts[0];
  }

  return null;
}

async function loginRedirect() {
  console.log('function loginRedirect');
  await initializePromise;
  await msal.loginRedirect({ scopes });
}

async function login() {
  if (!(await onlineService.getStatus())) {
    console.log('No internet connection');
    return null;
  }

  await initializePromise;

  const account = getAccount();
  if (account) {
    return account;
  }

  await loginRedirect();
  return null;
}

async function logoutRedirect() {
  console.log('function logoutRedirect');
  await initializePromise;
  return msal.logoutRedirect();
}

async function logout() {
  await initializePromise;
  await logoutRedirect();
}

async function handleRedirect() {
  console.log('handleRedirect');

  await initializePromise;
  const response = await msal.handleRedirectPromise();

  if (response?.account) {
    msal.setActiveAccount(response.account);
    return response.account;
  }

  return getAccount();
}

async function acquireToken(forceRefresh = false) {
  await initializePromise;

  const account = getAccount();
  if (!account) {
    return null;
  }

  try {
    const tokenOptions = {
      account,
      scopes,
    };

    if (forceRefresh) {
      tokenOptions.cacheLookupPolicy = CacheLookupPolicy.RefreshTokenAndNetwork;
    }

    const result = await msal.acquireTokenSilent(tokenOptions);

    if (result?.account) {
      msal.setActiveAccount(result.account);
    }

    sessionStorage.setItem('accessToken', result.accessToken);
    return result.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      await msal.acquireTokenRedirect({
        account,
        scopes,
      });
      return null;
    }

    if (
      err instanceof BrowserAuthError &&
      err.errorCode === 'interaction_in_progress'
    ) {
      console.warn('MSAL interaction already in progress, skipping redirect.');
      return null;
    }

    throw err;
  }
}

export { login, logout, handleRedirect, acquireToken };
